module.exports = __webpack_public_path__ + "img/FM.5f418bd7.svg";